"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ark } from "@ark-ui/react/factory";
import { forwardRef } from "react";
import { styled } from "@filadd/phi-plus-styled-system/jsx";
import { skeleton, } from "@filadd/phi-plus-styled-system/recipes";
const StyledSkeleton = styled(ark.div, skeleton);
export const Skeleton = forwardRef((props, ref) => {
    const { isLoaded } = props, otherProps = __rest(props, ["isLoaded"]);
    if (isLoaded) {
        return _jsx(styled.div, Object.assign({ animation: "fade-in", ref: ref }, otherProps));
    }
    return _jsx(StyledSkeleton, Object.assign({ ref: ref }, otherProps));
});
Skeleton.displayName = "Skeleton";
//# sourceMappingURL=Skeleton.js.map